import * as z from 'zod';
import { Get as Get$1 } from '../surety-quote-preview.response.mixins.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.baseSchema = (contractSuretyType) => Get$1.Response.baseSchema(contractSuretyType).extend({
            suretyType: z.literal("contract"),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
